import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { getWorkflowRestoreVersionDetails } from "services/workflows/workflowRestoreVersionRepository";

export interface WorkflowRestoreVersionDetails {
    profile: string;
    editorVersion: string;
    workflowUuid: string;
    versionId: string;
}

export interface WorkflowRestoreVersionState {
    workflowRestoreVersion: WorkflowRestoreVersionDetails | null;
}

const INITIAL_STATE: WorkflowRestoreVersionState = {
    workflowRestoreVersion: getWorkflowRestoreVersionDetails(),
};

const WORKFLOW_SLICE = createSlice({
    name: "workflowStore",
    initialState: INITIAL_STATE,
    reducers: {
        setRestoreWorkflowVersion(state, action: PayloadAction<WorkflowRestoreVersionDetails>) {
            state.workflowRestoreVersion = action.payload;
        },
        removeRestoreWorkflowVersion(state) {
            state.workflowRestoreVersion = null;
        },
    },
});

export const { setRestoreWorkflowVersion, removeRestoreWorkflowVersion } = WORKFLOW_SLICE.actions;

export default WORKFLOW_SLICE.reducer;
